import React, { useEffect, useState } from "react";
import PaginatedTable from "../common/PaginatedTable";
import DTIPages from "../common/DTIPages";
import { View } from "@instructure/ui-view";
import { Text } from "@instructure/ui-text";
import DtiToolbar from "../common/DtiToolbar";
import DtiKpiGrid from "../common/DtiKpiGrid";
import DtiSectionHeading from "../common/DtiSectionHeading";
import DtiOverviewSkeleton from "../common/DtiSkeleton";
import { downloadWithAuth } from "../../../utils";
import {
  getJobStudentOnlineRate,
  getStudentOnlineRate,
  createJobStudentOnlineRate,
  getInteractiveLessionRate,
  createJobInteractiveLessionRate,
  getJobInteractiveLessionRate
} from "../api/api";

export default function Interactive({ iframe = false }) {
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const applyData = async () => {
    const interactionData = [];
    const studentData = await getStudentOnlineRate()
    const teacherData = await getInteractiveLessionRate()
    interactionData.push({
      name: "Học sinh",
      count: studentData.totalStudents,
      totalActivities: studentData.totalActivities.toFixed(2),
      averageActivities: (studentData.totalActivities / studentData.totalStudents).toFixed(2)
    });
    interactionData.push({
      name: "Giáo viên",
      count: teacherData.totalTeacherCreatedLecture,
      totalActivities: teacherData.totalActivities.toFixed(2),
      averageActivities: (teacherData.totalActivities / teacherData.totalTeacherCreatedLecture).toFixed(2)
    });
    interactionData.push({
      name: "Tổng cộng",
      count: studentData.totalStudents + teacherData.totalTeacherCreatedLecture,
      totalActivities: (studentData.totalActivities + teacherData.totalActivities).toFixed(2),
      averageActivities: ((studentData.totalActivities + teacherData.totalActivities) / (studentData.totalStudents + teacherData.totalTeacherCreatedLecture)).toFixed(2)
    });
    
    setData(interactionData);
  };

  useEffect(() => {
    let intervalId;
    const fetchData = async () => {
      setIsFetching(true);
      try {
        await applyData();
        const job = await getJobStudentOnlineRate();
        const teacherJob = await getJobInteractiveLessionRate();
        if (["starting", "pending"].includes(job?.workflow_state) || ["starting", "pending"].includes(teacherJob?.workflow_state)) {
          setIsLoading(true);
          intervalId = setInterval(async () => {
            const jobStatus = await getJobStudentOnlineRate();
            const teacherJobStatus = await getJobInteractiveLessionRate();
            if (jobStatus?.workflow_state === "done" && teacherJobStatus?.workflow_state === "done") {
              setIsLoading(false);
              clearInterval(intervalId);
              setIsFetching(true);
              try {
                await applyData();
              } finally {
                setIsFetching(false);
              }
            }
          }, 1000);
        }
      } finally {
        setIsFetching(false);
      }
    };
    fetchData();
    return () => clearInterval(intervalId);
  }, []);

  const handleJob = async () => {
    if (isLoading) return;
    setIsLoading(true);
    await createJobStudentOnlineRate();
    await createJobInteractiveLessionRate();
    const intervalId = setInterval(async () => {
      const job = await getJobStudentOnlineRate();
      const teacherJob = await getJobInteractiveLessionRate();
      if (job?.workflow_state === "done" && teacherJob?.workflow_state === "done") {
        setIsLoading(false);
        clearInterval(intervalId);
        setIsFetching(true);
        try {
          await applyData();
        } finally {
          setIsFetching(false);
        }
      }
    }, 1000);
  };

  const showSkeleton = isFetching || isLoading;

  if (iframe) {
    return (
      <View as="div" margin="small" textAlign="center">
        <Text size="large">Bạn không được quyền truy cập</Text>
      </View>
    );
  }

  if (showSkeleton) {
    return <DtiOverviewSkeleton kpiCount={1} showExport />;
  }

  return (
    <>
      <DtiToolbar
        isLoading={isLoading}
        onRefresh={handleJob}
      />
      <DTIPages
        secondPage={
          <>
            
          </>
        }
        firstPage={
          <>
            <DtiSectionHeading>Thống kê dữ liệu hành vi người dùng</DtiSectionHeading>
            <PaginatedTable
              headers={[
                { id: "name", text: "Nhóm người dùng", width: "25%" },
                { id: "count", text: "Số lượng người dùng", width: "25%" },
                { id: "totalActivities", text: "Tổng dữ liệu hành vi/ngày", width: "25%" },
                { id: "averageActivities", text: "Trung bình dữ liệu hành vi/người/ngày", width: "25%" }
              ]}
              rows={data}
              perPage={10}
            />
          </>
        }
      />
    </>
  );
}
